import api from '@pray/shared/utils/api';

export const getRadioTakeover = async ({ artistId = null, dailyItemId = null } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!dailyItemId) throw Error('Daily Item ID is required');

  const url = `/web/studio/artists/${artistId}/daily-items/${dailyItemId}/radio-takeover`;
  const response = await api.executeGetRequest(url);

  return response.data;
};
